<template>
  <div class="bindList">
      <el-card class="listItem" @click.native="bindItem(item)" v-for="(item,ind) in list" :key="ind">
        <p>姓名：{{item.name}}</p>
        <p>地址：{{item.address}}</p>
      </el-card>
  </div>
</template>

<script>
  import {bindUser, findByMp, getBindYh} from "@/api";
  import { MessageBox } from 'mint-ui';
  export default {
    data() {
      return {
        list: []
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      getList() {
        if(!this.$route.query.type) {
          getBindYh(JSON.parse(this.$route.query.params)).then(res=> {
            this.list = res.data
          })
        } else {
          findByMp(JSON.parse(this.$route.query.params)).then(res=>{
            this.list = res.data
          })
        }

      },
      bindItem(item) {
        MessageBox.confirm('确认绑定该户?').then(action => {
          const data = {
            relationShip: this.$route.query.fz,
            customerId: item.id,
            customerCode: item.code,
            customerYhkh: item.yhkh
          }
          bindUser(data).then(res => {
            this.$router.push(sessionStorage.getItem('path'))
          })
        });
      }
    }
  }
</script>

<style scoped>
  .bindList{
    height: 90%;
    padding: 10px 0;
  }
  .listItem{
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/view/yhBind/bindList.vue